import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ServiceDetail.css";

const HealthcareService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Telemedicine",
      items: [
        "Video Consultations",
        "Remote Diagnosis",
        "Prescription Services",
        "Follow-up Care",
      ],
    },
    {
      title: "Health Monitoring",
      items: [
        "Vital Signs Tracking",
        "Chronic Disease Management",
        "Wellness Programs",
        "Health Reports",
      ],
    },
    {
      title: "Medical Records",
      items: [
        "Digital Health Records",
        "Secure Storage",
        "Easy Access",
        "Data Privacy",
      ],
    },
    {
      title: "24/7 Support",
      items: [
        "Round-the-Clock Access",
        "Emergency Consultations",
        "Health Advice",
        "Appointment Scheduling",
      ],
    },
  ];

  return (
    <div className="service-detail-page">
      <section className="service-detail-hero">
        <div className="hero-particles"></div>
        <div className="container">
          <Link to="/services" className="back-link">
            ← Back to Services
          </Link>
          <div className="service-detail-hero-content">
            <div className="service-icon-hero">🏥</div>
            <h1>Healthcare Solutions</h1>
            <p>
              Remote medical services powered by innovative technology for
              accessible, convenient healthcare
            </p>
          </div>
        </div>
      </section>

      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2>Quality Healthcare, Anywhere</h2>
              <p>
                Our telemedicine platform connects you with qualified healthcare
                professionals from the comfort of your home. Access quality
                medical consultations, health monitoring, and wellness programs
                through innovative technology.
              </p>
              <p>
                With secure digital health records and 24/7 support, managing
                your health has never been more convenient.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Access</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Secure</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-programs">
        <div className="container">
          <h2>Our Services</h2>
          <div className="programs-grid">
            {services.map((service, index) => (
              <div key={index} className="program-item">
                <h3>{service.title}</h3>
                <ul className="program-topics">
                  {service.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-cta">
        <div className="container">
          <h2>Ready to Access Better Healthcare?</h2>
          <p>Start your journey to convenient, quality medical care today</p>
          <Link to="/contact-us" className="btn btn-light">
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HealthcareService;
